import {
  collection,
  query,
  where,
  orderBy,
  getDocs
} from 'firebase/firestore';
import { Firestore } from '../Firebase';
import { problemConverter } from '../model/Problem';

export async function getProblems(
  parent: string | null,
  isPrivileged: boolean = false
) {
  const colRef = collection(Firestore, 'problems').withConverter(problemConverter);
  let q = query(colRef, where('parent', '==', parent));

  if (!isPrivileged) {
    q = query(q, where('public', '==', true));
  }

  q = query(q, orderBy('order'));
  
  return (await getDocs(q)).docs.map(doc => doc.data());
}

